import { Spinner } from '@components/spinner'
import { IdentityForm } from '@contentful-components/forms/identity'
import { ConditionalKycFormPage } from '@contentful-components/forms/identity/conditional-kyc-form-page'
import { useNavigation } from '@lib/hooks/useNavigation'
import type { PageWithContext } from '@lib/utils/context'
import { PAGE_OPTIONS } from '@lib/utils/page'
import { getAuthLayout } from '@page-templates/auth-page'

const Kyc: PageWithContext = () => {
    useNavigation({
        action: 'HELP_CENTER',
        showLinks: false,
    })

    return (
        <IdentityForm>
            <ConditionalKycFormPage {...PAGE_OPTIONS.KYC_COMBINED} />
        </IdentityForm>
    )
}

Kyc.getLayout = getAuthLayout(true, <Spinner size='large' />)

export default Kyc
